import {
  GET_WEB_BUILDER_DATA,
  GET_WEB_BUILDER_DATA_SUCCESS,
  GET_WEB_BUILDER_DATA_ERROR,
  UPDATE_WEB_BUILDER_STATE,
  HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION,
  HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_SUCCESS,
  HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_ERROR,
  SAVE_DESIGNER_DATA,
  SAVE_DESIGNER_SUCCESS,
  SAVE_DESIGNER_ERROR
} from "../actions";

const INIT_STATE = {
  loading: false,
  webBuilderError: "",
  saveDesignerDataError: "",
  collection: null,
  collectionItem: null,
  currentNode: null,
  pageContentItem: null,
  selectedCollectionItemOptions: null,
  toolboxElements: null,
  elements: null,
  masterPageElements: null,
  contents: null,
  masterContents: null,
  selectedCollectionItemOption: null,
  selectedCollectionItemOptionCategoryId: null,
  isSettingsPanelDisplayed: false,
  isNavigatorPanelDisplayed: false,
  optionParentField: null,
  placeholderProps: null,
  selectedElement: null,
  openedNodeIds: [],
  fieldOptionList: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_WEB_BUILDER_DATA:
      return { ...state, loading: true, webBuilderError: "", collection: null, collectionItem: null, currentNode: null, pageContentItem: null, collectionItemOptionCategories: [], selectedCollectionItemOptions: null, allCollectionItemOptions: null, elements: null, masterPageElements: null, toolboxElements: null, selectedCollectionItemOption: null, contents: null, masterContents: null };
    case GET_WEB_BUILDER_DATA_SUCCESS:
      return { ...state, loading: false, webBuilderError: "", collection: action.payload.collection, collectionItem: action.payload.collectionItem, currentNode: action.payload.currentNode, pageContentItem: action.payload.pageContentItem, collectionItemOptionCategories: action.payload.collectionItemOptionCategories, selectedCollectionItemOptions: action.payload.selectedCollectionItemOptions, allCollectionItemOptions: action.payload.allCollectionItemOptions, elements: action.payload.elements, masterPageElements: action.payload.masterPageElements, toolboxElements: action.payload.toolboxElements, selectedCollectionItemOption: action.payload.selectedCollectionItemOption, contents: action.payload.contents, masterContents: action.payload.masterContents, selectedElement: null, isSettingsPanelDisplayed: false, isNavigatorPanelDisplayed: false };
    case GET_WEB_BUILDER_DATA_ERROR:
      return { ...state, loading: false, webBuilderError: action.payload.message };
    case UPDATE_WEB_BUILDER_STATE:
      return { ...state, ...action.payload };
    case HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION:
      return { ...state, loading: true, updateCollectionItemOptionsError: "" };
    case HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_SUCCESS:
      return { ...state, loading: false, updateCollectionItemOptionsError: "", selectedCollectionItemOptions: action.payload.selectedCollectionItemOptions };
    case HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_ERROR:
      return { ...state, loading: false, updateCollectionItemOptionsError: action.payload.message };
    case SAVE_DESIGNER_DATA:
      return { ...state, loading: true, saveDesignerDataError: "" };
    case SAVE_DESIGNER_SUCCESS:
      return { ...state, loading: false, saveDesignerDataError: "", collection: action.payload.collection, collectionItem: action.payload.collectionItem, currentNode: action.payload.currentNode, pageContentItem: action.payload.pageContentItem, collectionItemOptionCategories: action.payload.collectionItemOptionCategories, selectedCollectionItemOptions: action.payload.selectedCollectionItemOptions, allCollectionItemOptions: action.payload.allCollectionItemOptions, elements: action.payload.elements, masterPageElements: action.payload.masterPageElements, toolboxElements: action.payload.toolboxElements, selectedCollectionItemOption: action.payload.selectedCollectionItemOption, contents: action.payload.contents, masterContents: action.payload.masterContents, selectedElement: null, isSettingsPanelDisplayed: false, isNavigatorPanelDisplayed: false };
    case SAVE_DESIGNER_ERROR:
      return { ...state, loading: false, saveDesignerDataError: action.payload.message };
    default:
      return { ...state };
  }
};
